import React from 'react';

const TabPane = ({ title, children }) => (
    <div className="tab-pane" data-title={title}>
        {children}
    </div>
);

export default TabPane;
